import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';
import { IconHeart } from '../../components';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const { listing, variantPrefix, currentUser, parentListing, onGalleryReady } = props;
  const images = listing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];
  
  // Always use parentListing for watchlist operations (parentListing is always the parent, whether viewing parent or variant)
  const listingId = parentListing?.id?.uuid || listing?.id?.uuid;
  
  // Get video data from publicData
  const { publicData = {} } = listing.attributes || {};
  const video = publicData.videoId ? {
    videoId: publicData.videoId
  } : null;
  
  // Always use parentListing's likes count for watchlist
  const parentMetadata = parentListing?.attributes?.metadata || {};
  const likesCount = parentMetadata.likesCount || 0;
  
  // Always show the heart icon
  const showHeartIcon = true;

  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        video={video}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        currentUser={currentUser}
        listing={listing}
        onGalleryReady={onGalleryReady}
      />
      {showHeartIcon && (
        <IconHeart
          className={css.galleryHeartIcon}
          listingId={listingId}
          initialLikesCount={likesCount}
        />
      )}
    </section>
  );
};

export default SectionGallery;
